module.exports = __webpack_public_path__ + "static/media/SAT-BUSD.616d3f2a.png";